import { ActionType } from 'typesafe-actions';
import { selectRegion } from '../../actions/configurations/selectRegion';
import { RootState } from '../rootReducer';

export const selectRegionCase = (
  state: RootState['configuration'],
  action: ActionType<typeof selectRegion>,
): RootState['configuration'] => ({
  ...state,
  region: action.payload,
});
